module.exports = {"component":"tooltip","status":"prod","display-name":"Tooltips","SLDS-component-path":"/components/tooltips","url-slug":"tooltips"}


//////////////////
// WEBPACK FOOTER
// ./components/tooltip/docs.json
// module id = 141
// module chunks = 0